import { API_BASE_URL, parseJsonResponse } from './apiConfig'

async function fetchWithTimeout(resource, options = {}, timeout = 30000) {
  const controller = new AbortController()
  const id = setTimeout(() => {
    console.warn(`Request timeout after ${timeout}ms for: ${resource}`)
    controller.abort()
  }, timeout)
  try {
    console.log(`Fetching: ${resource}`)
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    if (error.name === 'AbortError') {
      console.error(`Request aborted (timeout): ${resource}`)
      throw new Error(`Request timeout. Backend not responding. Check if server is running at ${API_BASE_URL}`)
    }
    throw error
  }
}

export async function fetchTodayAppointments(employeeId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/employee/${employeeId}/today`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 15000)

  if (!response.ok) {
    throw new Error('Failed to fetch today appointments')
  }

  const data = await parseJsonResponse(response, 'Failed to fetch today appointments')
  return Array.isArray(data) ? data : data?.appointments || data?.visitors || []
}

export async function fetchEmployeeAppointments(employeeId) {
  console.log('Fetching appointments for employee:', employeeId)
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/employee/${employeeId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 30000)

  console.log('Appointments fetch response status:', response.status)

  if (!response.ok) {
    const errorText = await response.text()
    console.error('Appointments fetch error response:', errorText)
    throw new Error(`Failed to fetch employee appointments: ${response.status} - ${errorText}`)
  }

  const data = await parseJsonResponse(response, 'Failed to fetch employee appointments')
  const appointments = Array.isArray(data) ? data : data?.appointments || data?.visitors || []
  console.log('Appointments fetched successfully, count:', appointments.length)
  return appointments
}

export async function acceptAppointment(visitorId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/${visitorId}/accept`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  }, 30000)

  if (!response.ok) {
    throw new Error('Failed to accept appointment')
  }

  return parseJsonResponse(response, 'Failed to accept appointment')
}

export async function rejectAppointment(visitorId, reason) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/${visitorId}/reject`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  }, 30000)

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Failed to reject appointment')
  }

  return parseJsonResponse(response, 'Failed to reject appointment')
}

export async function checkInVisitor(visitorId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/${visitorId}/check-in`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to check in visitor')
  }

  return parseJsonResponse(response, 'Failed to check in visitor')
}

export async function checkOutVisitor(visitorId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/${visitorId}/check-out`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to check out visitor')
  }

  return parseJsonResponse(response, 'Failed to check out visitor')
}

export async function fetchAppointmentsByStatus(status) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/appointments/status/${status}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to fetch appointments')
  }

  const data = await parseJsonResponse(response, 'Failed to fetch appointments')
  return Array.isArray(data) ? data : data?.appointments || data?.visitors || []
}
